import { useContext } from 'react';
import OrderRatingContext, { ProviderContext } from './OrderRatingContext';

const useOrderRating = (): ProviderContext => useContext(OrderRatingContext)
export default useOrderRating;